(() => {
  const initialize = (bar) => {
    if (bar.dataset.announcementBound === 'true') return;
    bar.dataset.announcementBound = 'true';
    const messages = [...bar.querySelectorAll('[data-announcement-message]')];
    const previous = bar.querySelector('[data-announcement-previous]');
    const next = bar.querySelector('[data-announcement-next]');
    const status = bar.querySelector('[data-announcement-status]');
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let available = [];
    let current = 0;
    let hovered = false;
    let focused = false;
    let rotationTimer;
    let deadlineTimer;
    let touch;
    const removers = [];
    const listen = (target, name, handler, options) => {
      target.addEventListener(name, handler, options);
      removers.push(() => target.removeEventListener(name, handler, options));
    };
    const canRotate = () => available.length > 1 && !motion.matches && !hovered && !focused && !document.hidden;
    const scheduleRotation = () => {
      window.clearTimeout(rotationTimer);
      if (canRotate()) rotationTimer = window.setTimeout(() => {
        show(current + 1);
        scheduleRotation();
      }, 4500);
    };
    const show = (index, announce = true) => {
      if (!available.length) return;
      current = (index + available.length) % available.length;
      const active = available[current];
      messages.forEach(message => {
        const selected = message === active;
        message.classList.toggle('is-active', selected);
        message.setAttribute('aria-hidden', String(!selected));
        message.toggleAttribute('inert', !selected);
      });
      if (announce && status) {
        const variant = active.querySelector(window.matchMedia('(max-width: 1023px)').matches ? '.he-ann__mobile' : '.he-ann__desktop');
        status.textContent = (variant || active).textContent.trim();
      }
    };
    const refresh = (announce = true) => {
      const active = available[current] || messages.find(message => message.classList.contains('is-active'));
      const now = Date.now();
      messages.forEach(message => {
        const deadline = Date.parse(message.dataset.endsAt || '');
        message.hidden = Number.isFinite(deadline) && now >= deadline;
      });
      const normal = messages.filter(message => !message.hasAttribute('data-announcement-fallback') && !message.hidden);
      messages.filter(message => message.hasAttribute('data-announcement-fallback')).forEach(message => { message.hidden = normal.length > 0; });
      available = normal.length ? normal : messages.filter(message => message.hasAttribute('data-announcement-fallback'));
      const activeIndex = available.indexOf(active);
      show(activeIndex < 0 ? 0 : activeIndex, announce);
      if (previous) previous.hidden = available.length < 2;
      if (next) next.hidden = available.length < 2;
      window.clearTimeout(deadlineTimer);
      const future = messages.map(message => Date.parse(message.dataset.endsAt || '')).filter(deadline => Number.isFinite(deadline) && deadline > now);
      if (future.length) deadlineTimer = window.setTimeout(refresh, Math.min(Math.min(...future) - now, 2147483647));
      scheduleRotation();
    };
    const move = direction => {
      show(current + direction);
      scheduleRotation();
    };
    if (previous) listen(previous, 'click', () => move(-1));
    if (next) listen(next, 'click', () => move(1));
    listen(bar, 'mouseenter', () => { hovered = true; scheduleRotation(); });
    listen(bar, 'mouseleave', () => { hovered = false; scheduleRotation(); });
    listen(bar, 'focusin', () => { focused = true; scheduleRotation(); });
    listen(bar, 'focusout', event => { focused = !!event.relatedTarget && bar.contains(event.relatedTarget); scheduleRotation(); });
    listen(bar, 'touchstart', event => {
      const point = event.touches[0];
      touch = point ? { x: point.clientX, y: point.clientY } : null;
    }, { passive: true });
    listen(bar, 'touchend', event => {
      const point = event.changedTouches[0];
      if (!touch || !point) return;
      const x = point.clientX - touch.x;
      const y = point.clientY - touch.y;
      touch = null;
      if (Math.abs(x) < 40 || Math.abs(x) <= Math.abs(y)) return;
      event.preventDefault();
      move(x < 0 ? 1 : -1);
    }, { passive: false });
    listen(bar, 'touchcancel', () => { touch = null; }, { passive: true });
    listen(document, 'visibilitychange', refresh);
    listen(motion, 'change', scheduleRotation);
    listen(bar, 'shopify:block:select', event => {
      const selected = event.target.closest('[data-announcement-message]');
      const index = available.indexOf(selected);
      if (index >= 0) { show(index); focused = true; scheduleRotation(); }
    });
    listen(bar, 'shopify:block:deselect', () => { focused = bar.contains(document.activeElement); scheduleRotation(); });
    bar.hewnAnnouncementDestroy = () => {
      window.clearTimeout(rotationTimer);
      window.clearTimeout(deadlineTimer);
      removers.forEach(remove => remove());
      delete bar.dataset.announcementBound;
    };
    refresh(false);
  };
  const initializeWithin = scope => {
    if (scope.matches?.('[data-promo-announcement]')) initialize(scope);
    scope.querySelectorAll('[data-promo-announcement]').forEach(initialize);
  };
  initializeWithin(document);
  document.addEventListener('shopify:section:load', event => initializeWithin(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-promo-announcement]').forEach(bar => bar.hewnAnnouncementDestroy?.());
  });
})();
